import { Flow } from 'vivaa-api';

export const FlowKind = Flow.FlowKind;
export type FlowKind = Flow.FlowKind;

export const COMMON_HELPER_MESSAGES = {
  documentSource: `Documents extracted based on filters set by the configurer on the Document Extract block.`,
  labValuesSource: `Patient's lab results extracted from the LabValues FHIR block configured to fetch lab values.`,
  medicationsSource: `Patient's medications extracted from the Medications FHIR block configured to fetch medications.`,
  problemsSource: `Patient's conditions extracted from the Conditions FHIR block configured to fetch conditions.`,
  proceduresSource: `Patient's surgical history extracted from the SurgicalHistories FHIR block configured to fetch surgical histories.`,
};

export interface SharedBlockFormFieldsProps {
  fieldNamePrefix: string;
  variant: 'SubflowPicker' | 'SkillV2';
  allowedFlowKinds: FlowKind[];
}

export const SubflowOrSkillV2FlowKinds = [FlowKind.Base, FlowKind.Skill];
